import {
  LB_FILTER_LBL,
  LB_QUARTER_DISPLAY,
  LB_QUARTER_VALUE,
} from "../../Utils/Helper/discoveryHubUi";
import { formatQuarterPeriodLabel } from "../../Utils/Helper/sponsorEngagementUi";

type LeaderboardPeriodSelectorProps = {
  options: string[];
  value?: string;
  onChange?: (period: string) => void;
  className?: string;
};

const LeaderboardPeriodSelector = ({
  options,
  value,
  onChange,
  className = "",
}: LeaderboardPeriodSelectorProps) => {
  if (options.length === 0) return null;

  const resolvedValue = value || options[0];

  return (
    <div className={`${LB_QUARTER_DISPLAY} ${className}`.trim()}>
      <span className={LB_FILTER_LBL}>Quarter</span>
      {onChange && options.length > 1 ? (
        <select
          value={resolvedValue}
          onChange={e => onChange(e.target.value)}
          aria-label="Select quarter"
        >
          {options.map(p => (
            <option key={p} value={p}>
              {formatQuarterPeriodLabel(p)}
            </option>
          ))}
        </select>
      ) : (
        <span className={LB_QUARTER_VALUE}>
          {formatQuarterPeriodLabel(resolvedValue)}
        </span>
      )}
    </div>
  );
};

export default LeaderboardPeriodSelector;
